
import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

interface PostMetadataBasicFieldsProps {
  title: string;
  setTitle: (title: string) => void;
  slug: string;
  setSlug: (slug: string) => void;
  excerpt: string;
  setExcerpt: (excerpt: string) => void;
  author: string;
  setAuthor: (author: string) => void;
}

const PostMetadataBasicFields: React.FC<PostMetadataBasicFieldsProps> = ({
  title,
  setTitle,
  slug,
  setSlug,
  excerpt,
  setExcerpt,
  author,
  setAuthor,
}) => {
  // Function to convert title to slug
  const generateSlug = (text: string) => {
    return text
      .toLowerCase()
      .replace(/[^\w\s]/gi, "")
      .replace(/\s+/g, "-");
  };

  // Handle title change and auto-generate slug if needed
  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newTitle = e.target.value;
    setTitle(newTitle);
    
    // Only auto-generate slug if user hasn't manually edited it
    if (!slug || slug === generateSlug(title)) {
      setSlug(generateSlug(newTitle));
    }
  };

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="title">Title <span className="text-red-500">*</span></Label>
        <Input
          id="title"
          value={title}
          onChange={handleTitleChange}
          placeholder="Enter post title"
          required
        />
        <p className="text-xs text-muted-foreground">
          {title.length} characters
        </p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="slug">URL Slug <span className="text-red-500">*</span></Label>
        <Input
          id="slug"
          value={slug}
          onChange={(e) => setSlug(e.target.value)}
          placeholder="post-url-slug"
          required
        />
        <p className="text-xs text-muted-foreground">
          This will be used in the URL: https://yoursite.com/blog/{slug}
        </p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="excerpt">Excerpt <span className="text-red-500">*</span></Label>
        <Textarea
          id="excerpt"
          value={excerpt}
          onChange={(e) => setExcerpt(e.target.value)}
          placeholder="Brief description of the post (displayed in previews)"
          rows={3}
          required
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="author">Author</Label>
        <Input
          id="author"
          value={author}
          onChange={(e) => setAuthor(e.target.value)}
          placeholder="Author name"
        />
      </div>
    </div>
  );
};

export default PostMetadataBasicFields;
